import {
  Box,
  Button,
  Container,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import {
  ErrorModal,
  GeneralModal,
  HeaderWithButtons,
  InfoBox,
  InfoLine,
  RemoveCategoryModal,
} from "../components-molecules";
import {
  getCategoryDetailsSymbols,
  removeCategoryDetails,
} from "../redux/actions/getCategoryDetails";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import CssBaseline from "@material-ui/core/CssBaseline";
import { FormControl } from "@material-ui/core";
import { HttpRegularPut } from "../service";
import { Subcategories } from "../components-organisms/Subcategories";
import { getVerticalsSymbols } from "../redux/actions/getVerticals";
import { colours, theme } from "../constants/theme";
import { clearSubCategorysSymbols } from "../redux/actions/getSubcategories";
import trashIcon from "../assets/icons/trash-icon.svg";
import { CircularProggressIndicator } from "../components-atoms";
import { textButtonHoverAndActive } from "../utils/styles/buttonStyles";
import { useTranslation } from 'react-i18next';

// import { setError } from "../redux/actions/error";

export const CategoryDetails = (props: any) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  //const [logo, setLogo] = useState<any>();
  let { id }: { id: string } = useParams();
  const [name, setName] = useState("");
  const [vertical, setVertical] = useState<any>();
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [verticalData, setAllVerticals] = useState<Array<any>>([]);
  const [editType, setEditType] = useState("");
  const [removeModal, setRemoveModal] = useState(false);
  const [removeConfirm, setRemoveConfirm] = useState(false);
  //const [dataDetails, setDataDetails] = useState<any>();
  useEffect(() => {
    dispatch(clearSubCategorysSymbols());
    dispatch(getCategoryDetailsSymbols(id));
    dispatch(getVerticalsSymbols());
  }, []); // eslint-disable-line

  const data = useSelector(
    (state: any) => state.CategoryDetailsSymbolsReducer.data
  );
  const loading = useSelector(
    (state: any) => state.CategoryDetailsSymbolsReducer.loading
  );
  const subcategoryData = useSelector(
    (state: any) => state.SubcategorySymbolsReducer.data
  );
  /* useEffect(() => {
    if (previousData && previousData.Id !== data.Id) {
      setDataDetails(data);
    }
  }, [data]); // eslint-disable-line */

  const vData = useSelector((state: any) => state.VerticalSymbolsReducer.data);

  useEffect(() => {
    if (vData && vData.length > 0 && data) {
      let allVerticals: Array<any> = [];
      vData.forEach((d: any) => {
        if (d[1].length > 0) allVerticals = [...allVerticals, ...d[1]];
      });

      setVertical(allVerticals.find((i: any) => i.Id === data.VerticalId));
      setAllVerticals(allVerticals);
    }
  }, [vData, data]);

  const handleSubmit = () => {
    switch (editType) {
      case "Name":
        dispatch(handleSubmitBasicInfo("Name"));
        break;
      case "Description":
        dispatch(handleSubmitBasicInfo("Description"));
        break;
      default: {
        setEditModalOpen(false);
      }
    }
    //dispatch(getAccountDetails());
    setEditModalOpen(false);
  };

  const handleSubmitBasicInfo = (infoType: string) => {
    const body = {
      Name: data?.Title,
      VerticalId: data?.VerticalId,
      Description: "",
    };
    if (infoType === "Name") {
      body.Name = name;
      setName("");
    } else if (infoType === "Description") {
      body.VerticalId = vertical.Id;
    } else {
    }
    return (disp: any) => {
      const fData = new FormData();
      fData.append(
        "json",
        JSON.stringify({
          Name: body.Name,
          Description: "",
          VerticalId: body.VerticalId,
        })
      );

      HttpRegularPut("/upc/category/" + id, fData, {
        dispatch: disp,
        actionSuccess: () => getCategoryDetailsSymbols(id),
        // actionFailure: () => setError("Could not update!"),
      });
    };
  };

  return (
    <Box className={classes.container}>
      {loading ? (
        <CircularProggressIndicator />
      ) : (
        <>
          <CssBaseline />
          <Container className={classes.root}>
            <HeaderWithButtons
              handleBack={() => history.goBack()}
              title={data?.Title ?? "Category Name"}
              smallText="Category"
            >
              <HeaderWithButtons.ButtonArea>
                <Button
                  onClick={() => {
                    if (subcategoryData.length === 0) {
                      setRemoveConfirm(true);
                    } else {
                      setRemoveModal(true);
                    }
                  }}
                  className={classes.removeButton}
                >
                  <img
                    src={trashIcon}
                    className={classes.buttonIcon}
                    alt="print icon"
                  />
                  <Typography variant="button" component="p" color="primary">
                    Remove
                  </Typography>
                </Button>
              </HeaderWithButtons.ButtonArea>
            </HeaderWithButtons>
            {/** alse || shopDetailsLoading || data.length === 0 ? */}
            <>
              <Container className={classes.detailsContainer}>
                <InfoBox title={t('admin.basicInformation')}>
                  <Grid item xs={12} className={classes.mt12b9}>
                    <Typography
                      variant="body2"
                      component="span"
                      color="textSecondary"
                    >
{t('admin.thisInformationWillBeVisible')}
                    </Typography>
                  </Grid>

                  <InfoLine
name={t('admin.categoryName')}
                    value={data?.Title ? data.Title : t('admin.pleaseSet')}
                    onClick={() => {
                      setEditType("Name");
                      setName(data?.Title ?? "");
                      setModalTitle("Category Name");
                      setEditModalOpen(true);
                    }}
                  >
                    <InfoLine.ArrowArea></InfoLine.ArrowArea>
                  </InfoLine>
                  <InfoLine
                    name="VERTICAL NAME"
                    isLastRow
                    value={
                      data?.VerticalName ? data.VerticalName : "Please set…"
                    }
                    onClick={() => {
                      setModalTitle("Vertical");
                      setEditType("Description");
                      setEditModalOpen(true);
                    }}
                  >
                    <InfoLine.ArrowArea></InfoLine.ArrowArea>
                  </InfoLine>
                </InfoBox>
                <Subcategories isUnderPage Category={data} />
                <GeneralModal
                  visible={editModalOpen}
                  title={modalTitle}
                  description=""
                  onClose={setEditModalOpen}
                >
                  <GeneralModal.ContentArea>
                    {editType === "Name" ? (
                      <TextField
                        placeholder="Category Name"
                        value={name}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        id="Name"
                        label="Name"
                        name="Name"
                        onChange={(e) => setName(e.target.value)}
                        autoFocus
                        InputProps={{
                          classes: {
                            root: classes.cssOutlinedInput,
                            focused: classes.cssFocused,
                            notchedOutline: classes.notchedOutline,
                          },
                        }}
                      />
                    ) : editType === "Description" ? (
                      <div className={classes.pt15}>
                        <FormControl
                          variant="outlined"
                          className={classes.selectArea}
                        >
                          <InputLabel id="demo-simple-select-outlined-label">
                            Vertical
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            value={vertical.Id}
                            onChange={(event: any) => {
                              setVertical(
                                verticalData.find(
                                  (i: any) => i.Id === event.target.value
                                )
                              );
                              //setSelectedVertical();
                            }}
                            label="Vertical"
                          >
                            {verticalData &&
                              verticalData.map((v: any, index: number) => (
                                <MenuItem key={index} value={v.Id}>
                                  {v.Name}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      </div>
                    ) : (
                      <></>
                    )}
                  </GeneralModal.ContentArea>
                  <GeneralModal.ButtonArea>
                    <Button
                      onClick={() => setEditModalOpen(false)}
                      className={classes.cancelButton}
                    >
                      <Typography
                        variant="button"
                        component="p"
                        color="primary"
                      >
                        Cancel
                      </Typography>
                    </Button>
                    <Button
                      onClick={handleSubmit}
                      className={classes.submitButton}
                    >
                      <Typography
                        variant="button"
                        component="p"
                        color="inherit"
                      >
                        Submit
                      </Typography>
                    </Button>
                  </GeneralModal.ButtonArea>
                </GeneralModal>
                <ErrorModal
                  errorBody="Please unbind all sub categories before removing the category. Once all sub categories are unbound you will be able to remove the category."
                  title="Remove category"
                  visible={removeModal}
                  onClose={() => setRemoveModal(false)}
                />
                <RemoveCategoryModal
                  onClose={() => setRemoveConfirm(false)}
                  open={removeConfirm}
                  onDelete={() =>
                    dispatch(
                      removeCategoryDetails(id, null, () => {
                        history.goBack();
                      })
                    )
                  }
                />
              </Container>
            </>
          </Container>
        </>
      )}
    </Box>
  );
};
const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  imageList: {
    display: "flex",
    flexDirection: "row",
    marginTop: 15,
    paddingLeft: 0,
  },
  images: {
    width: 200,
    height: 150,
    marginRight: 10,
  },
  submitButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  cancelButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.secondary.main,
    marginRight: "8px",
  },
  removeButton: {
    borderRadius: "8px",
    padding: "6px 16px 6px 12px",
    backgroundColor: colours.highEmphasis04,
    ...textButtonHoverAndActive
  },
  buttonIcon: {
    width: "18px",
    height: "18px",
    marginRight: 8,
  },
  cssOutlinedInput: {
    display: "flex",
    "&$cssFocused $notchedOutline": {
      border: `1px solid ${theme.palette.primary.main}`,

    },
  },

  cssFocused: {},

  notchedOutline: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  printButtonText: {
    textTransform: "none",
  },
  root: {
    maxWidth: "840px",
    paddingLeft: 0,
    paddingRight: 0,
  },
  detailsContainer: {
    marginTop: "24px",
    paddingLeft: 0,
    paddingRight: 0,
  },
  printableSection: {
    display: "none",
  },
  infoTextContainer: {
    alignItems: "center",
    paddingTop: 15,
    paddingBottom: 15,
    borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
  },
  uMb8: {
    marginBottom: 8,
  },
  mt12b9: {
    marginTop: 12,
    marginBottom: 9,
  },
  selectArea: { width: "100%", marginBottom: 15 },
  pt15: {
    paddingTop: 15,
  },
});
